


class DocumentstatusResponse {
    constructor(user_Id, type, documentStatus,status,message) {
        this.user_Id = user_Id;
        this.type = type;
        this.documentStatus = documentStatus;
        this.status = status;
        this.message = message;
    }

    static fromJson(json) {
      

        return new DocumentstatusResponse(
            json.user_Id,
            json.type,
            json.documentStatus,
            json.status,
            json.message,
        );
    }
}

export default DocumentstatusResponse;